const RDPHeaderData = [
  {
    title: 'Accueil',
    link: '/'
  },
  {
    title: 'Produits',
    link: '/produits',
    dropdown: [
      {
        title: 'Tout',
        link: '/produits/tout'
      },
      {
        title: 'Vin',
        link: '/produits/vin'
      },
      {
        title: 'Bière',
        link: '/produits/biere'
      },
      {
        title: 'Spiritueux',
        link: '/produits/spiritueux'
      },
      {
        title: 'Bocaux',
        link: '/produits/bocaux'
      },
      {
        title: 'Soft drinks',
        link: '/produits/soft-drinks'
      },
      {
        title: 'Huiles et Sauces',
        link: '/produits/huiles-sauces'
      },
      {
        title: 'Bouteilles en PET',
        link: '/produits/pet'
      },
      {
        title: 'Bouteilles décorées',
        link: '/produits/decorees'
      }
    ]
  },
  {
    title: 'À propos',
    link: '/a-propos'
  },
  {
    title: 'Services',
    link: '/services'
  },
  {
    title: 'Actualités',
    link: '/actualites'
  },
  {
    title: 'Contact',
    link: '/contact'
  }
]

export default RDPHeaderData
